// extracted by mini-css-extract-plugin
export default {"button":"PhotoUploadButton_button__60zna"};